import type { DragEndEvent } from '@dnd-kit/core';
import { DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
    SortableContext,
    arrayMove,
    useSortable,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, Select, Space, Table, Tooltip, Upload, UploadProps, notification, message, Row as AntRow, Col, Divider } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import Banner1 from '../../assets/image/banner1.svg';
import Banner2 from '../../assets/image/banner2.svg';
import Banner3 from '../../assets/image/banner3.svg';
import Banner4 from '../../assets/image/banner4.svg';
import Banner5 from '../../assets/image/banner5.svg';
import Banner6 from '../../assets/image/banner6.svg';
import { 
    DeleteOutlined, 
    EditOutlined, 
    EyeFilled, 
    EyeOutlined, 
    PlusOutlined,
    BookOutlined,
    FileTextOutlined,
    PictureOutlined,
    ContainerOutlined,
    UserOutlined,
    CloseOutlined
} from '@ant-design/icons';
import './banner.styles.scss'
import axios from 'axios';
import { API_URL } from '../../enums/api.enums';
import { useDispatchRoot, useSelectorRoot } from '../../redux/store';
import { addCollectionRequest, getBookRequest, getListCollectionRequest } from '../../redux/controller';
import { IGetBooksRequest } from '../../common/book.interface';
import { QUERY_PARAM } from '../../constants/get-api.constant';
import CTable from '../../components/table/CTable';
import moment from 'moment';
import Utils from '../../utils/base-utils';


interface DataType {
    key: string;
    title: string;
    name: string;
    description: string;
    image: string;
    action?: string;
    id?: string;
    bookIds?: any;
}
interface RowProps extends React.HTMLAttributes<HTMLTableRowElement> {
    'data-row-key': string;
}

const Row = (props: RowProps) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: props['data-row-key'],
    });

    const style: React.CSSProperties = {
        ...props.style,
        transform: CSS.Transform.toString(transform && { ...transform, scaleY: 1 }),
        transition,
        cursor: 'move',
        ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
    };

    return <tr {...props} ref={setNodeRef} style={style} {...attributes} {...listeners} />;
};

const uploadButton = (
    <div>
        <div style={{ marginTop: 8 }}>Tải ảnh banner</div>
    </div>
);
const Banner: React.FC = () => {
    const [dataSource, setDataSource] = useState<any>([]);
    const [isOpenModalAdd, setIsOpenModalAdd] = useState(false);
    const [imageUploadLst, setImageUploadLst] = useState<any[]>([]);
    const [checkLstImageUploadLst, setCheckLstImageUploadLst] = useState<any>([]);
    const [isOpenModalEdit, setIsOpenModalEdit] = useState(false);
    const dispatch = useDispatchRoot();
    const [currentSearchValue, setCurrentSearchValue] = useState<IGetBooksRequest>({ limit: 100, page: 1 });
    const [currentSearchValueCollection, setCurrentSearchValueCollection] = useState<any>({ limit: 10, offset: 0 });
    const {
        bookList,
        listCollection
    } = useSelectorRoot((state) => state.management);
    const [form] = Form.useForm();
    const [headers, setHeaders] = useState<any>({});
    const [lstBookInCollection, setLstBookInCollection] = useState<any>([]);
    const [isOpenModalView, setIsOpenModalView] = useState(false);
    const [idEditCollection, setIdEditCollection] = useState<any>(null);
    const [idEdit, setIdEdit] = useState<any>(null);
    const [imageCacheKey, setImageCacheKey] = useState<number>(0);
    const columns: ColumnsType<DataType> = [
        {
            title: 'STT',
            dataIndex: 'key',
            width: 100,
        },
        {
            title: 'Tiêu đề ',
            dataIndex: 'title',
        },
        {
            title: 'Tên',
            dataIndex: 'name',
        },
        {
            title: 'Mô tả',
            dataIndex: 'description',
        },
        {
            title: 'Hình ảnh',
            dataIndex: 'image',
            render: (_, record) => <img src={`${API_URL.HOST}/collection/thumbnail/${record.id}?t=${imageCacheKey}`} alt="tuyển tập" style={{ width: '100px', height: '100px' }} />
        },
        {
            title: 'Hành động',
            dataIndex: 'action',
            render: (_, record) => (
                <Space size="middle" style={{ display: 'flex', justifyContent: 'center' }}>
                    <Tooltip placement='top' title={"Xem sách tuyển tập"}>
                        <EyeOutlined onClick={(event) => handleView(record)} />
                    </Tooltip>
                    <Tooltip placement="top" title={"Chỉnh sửa"} >
                        <EditOutlined onClick={(event) => handleEdit(record)} />
                    </Tooltip>
                    <Tooltip placement="top" title={"Xóa"}>
                        <DeleteOutlined onClick={(event) => handleDelete(record)} />
                    </Tooltip>

                </Space>
            )
        },
    ];
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                // https://docs.dndkit.com/api-documentation/sensors/pointer#activation-constraints
                distance: 1,
            },
        }),
    );

    useEffect(() => {
        dispatch(getListCollectionRequest(currentSearchValueCollection));
        dispatch(getBookRequest(currentSearchValue));

        // get token from local storage
        let token = localStorage.getItem('token');
        if (token) {
            token = token.replace(/"/g, '');
            setHeaders({ 'Authorization': `Bearer ${token}`, })
        }
    }, []);

    useEffect(() => {
        console.log(dataSource);
    }, [dataSource]);

    useEffect(() => {
        console.log(listCollection);
        if (listCollection.length > 0) {
            const tmp = listCollection.map((item: any, index: any) => {
                return {
                    key: index + 1,
                    title: item.title,
                    name: item.name,
                    description: item.description,
                    image: item.image,
                    id: item.id,
                }

            });
            setDataSource(tmp);
        }
    }, [listCollection]);

    const onDragEnd = async ({ active, over }: DragEndEvent) => {
        if (active.id !== over?.id) {
            setDataSource((prev: any) => {
                const activeIndex = prev.findIndex((i: any) => i.key === active.id);
                const overIndex = prev.findIndex((i: any) => i.key === over?.id);
                return arrayMove(prev, activeIndex, overIndex);
            });

            const idLst = dataSource.map((item: any) => item.id);
            const activeIndex = dataSource.findIndex((i: any) => i.key === active.id);
            const overIndex = dataSource.findIndex((i: any) => i.key === over?.id);
            const tmp = arrayMove(idLst, activeIndex, overIndex);
            console.log(tmp);

            const req = {
                collectionIds: tmp.map((item: any) => item.toString())
            }

            console.log(req);

            await axios.post(`${API_URL.HOST}/collection/update-order`, req, {
                headers: headers
            })
                .then((res) => {
                    console.log(res);
                    notification.success({
                        message: 'Thành công',
                        description: 'Thay đổi vị trí tuyển tập thành công',
                        duration: 2,
                    } as any);

                    dispatch(getListCollectionRequest(currentSearchValueCollection));

                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const handleAdd = () => {
        setIsOpenModalAdd(true);
    };

    const handleChangeFileLst: UploadProps["onChange"] = ({
        fileList: newFileList,
    }) => {
        setCheckLstImageUploadLst(newFileList);
    };

    const handleFinishAddBanner = async (values: any) => {
        console.log('imageUploadLst:', imageUploadLst);

        const req = {
            title: values.title,
            name: values.name,
            description: values.description,
            bookIds: values.bookIds,
        }

        try {
            const res = await axios.post(`${API_URL.HOST}/collection`, req, {
                headers: headers
            });
            console.log('Collection created:', res.data.data);

            const collectionId = res.data.data.id;

            if (imageUploadLst.length > 0 && imageUploadLst[0]) {
                const formData = new FormData();
                formData.append('thumbnail', imageUploadLst[0]);
                formData.append('collectionId', collectionId.toString());

                try {
                    const uploadRes = await axios.post(`${API_URL.HOST}/collection/upload-thumbnail`, formData, {
                        headers: {
                            'Authorization': headers.Authorization,
                        }
                    });
                    console.log('Thumbnail uploaded:', uploadRes);
                } catch (uploadErr: any) {
                    console.error('Thumbnail upload error:', uploadErr?.response?.data || uploadErr);
                    notification.warning({
                        message: 'Tạo tuyển tập thành công',
                        description: 'Nhưng upload ảnh thumbnail bị lỗi. Bạn có thể sửa lại sau.',
                    } as any);
                }
            }

            notification.success({
                message: 'Thành công',
                description: 'Thêm mới tuyển tập thành công',
            } as any);
            setImageCacheKey(Date.now());
            dispatch(getListCollectionRequest(currentSearchValueCollection));
            setIsOpenModalAdd(false);
            form.resetFields();
            setImageUploadLst([]);
        } catch (err) {
            console.error('Error creating collection:', err);
            notification.error({
                message: 'Lỗi',
                description: 'Không thể tạo tuyển tập',
            } as any);
        }
    }

    const handleEdit = async (record: any) => {
        console.log(record);
        setIdEditCollection(record.id);
        await axios.get(`${API_URL.HOST}/collection/${record.id}`)
            .then((res) => {
                console.log(res.data.data);
                let bookIs = [];
                if (res.data.data.CollectionBook && res.data.data.CollectionBook.length > 0) {
                    bookIs = res.data.data.CollectionBook.map((item: any) => item.bookId);
                }
                form.setFieldsValue({
                    title: record.title,
                    name: record.name,
                    description: record.description,
                    bookIds: bookIs ? bookIs : null,
                    image: record.image,
                });
                setIdEdit(record.id);
                setIsOpenModalEdit(true);

            })
            .catch((err) => {
                console.log(err);
            });


    }

    const handleDelete = async (record: any) => {
        console.log(record);

        await axios.delete(`${API_URL.HOST}/collection/${record.id}`, {
            headers: headers
        })
            .then((res) => {
                console.log(res);
                notification.success({
                    message: 'Thành công',
                    description: 'Xóa tuyển tập thành công',
                    duration: 2,
                } as any);
                dispatch(getListCollectionRequest(currentSearchValueCollection));
            })
            .catch((err) => {
                console.log(err);
            });


    }

    const handleView = async (record: any) => {

        await axios.get(`${API_URL.HOST}/collection/${record.id}`)
            .then((res) => {
                console.log(res.data.data);
                if (res.data.data.CollectionBook && res.data.data.CollectionBook.length > 0) {
                    setIsOpenModalView(true);
                    setLstBookInCollection(res.data.data.CollectionBook);
                }
                else {
                    notification.warning({
                        message: 'Cảnh báo',
                        description: 'Tuyển tập này chưa có sách',
                        duration: 2,
                    } as any);
                }
            })
            .catch((err) => {
                console.log(err);
            });

    }

    const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        // setCurrentSearchValue({ ...currentSearchValue, [e.target.name]: e.target.value });
    };

    const onSearch = () => {
        // dispatch(getBookRequest(currentSearchValue));
    };

    const handleEditBanner = async (values: any) => {
        console.log(imageUploadLst[0]);
        const req = {
            title: values.title,
            name: values.name,
            description: values.description,
            bookIds: values.bookIds,
        }
        console.log(req);

        try {
            await axios.put(`${API_URL.HOST}/collection/${idEditCollection}`, req, {
                headers: headers
            });

            if (imageUploadLst.length > 0 && imageUploadLst[0]) {
                const formData = new FormData();
                formData.append('thumbnail', imageUploadLst[0]);
                formData.append('collectionId', idEditCollection);

                await axios.post(`${API_URL.HOST}/collection/upload-thumbnail`, formData, {
                    headers: headers
                });
            }

            notification.success({
                message: 'Thành công',
                description: 'Sửa tuyển tập thành công',
            } as any);
            setImageCacheKey(Date.now());
            dispatch(getListCollectionRequest(currentSearchValueCollection));
            setIsOpenModalEdit(false);
            form.resetFields();
            setImageUploadLst([]);
        } catch (err) {
            console.error('Error editing collection:', err);
            notification.error({
                message: 'Lỗi',
                description: 'Không thể sửa tuyển tập',
            } as any);
        }
    }

    return (
        <div className='main-banner'>
            <div className='main-banner-container'>
                <div className='main-banner-title'>
                    <h2>
                        <ContainerOutlined style={{ marginRight: '8px', color: 'var(--primary-color)' }} />
                        Quản lý tuyển tập
                    </h2>
                    <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
                        Thêm mới
                    </Button>
                </div>
                <div className='banner-table'>
                    <DndContext sensors={sensors} modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
                        <SortableContext
                            // rowKey array
                            items={dataSource.map((i: any) => i.key)}
                            strategy={verticalListSortingStrategy}
                        >
                            <Table
                                components={{
                                    body: {
                                        row: Row,
                                    },
                                }}
                                rowKey="key"
                                columns={columns}
                                dataSource={dataSource}
                                scroll={{ y: 500, x: 800 }}

                            />
                        </SortableContext>
                    </DndContext>
                </div>
            </div>
            <Modal
                title={
                    <Space>
                        <PlusOutlined />
                        <span>Thêm mới tuyển tập</span>
                    </Space>
                }
                visible={isOpenModalAdd}
                onCancel={() => setIsOpenModalAdd(false)}
                footer={null}
                style={{ top: 20, zIndex: 1050 }}
                className="banner-modal"
                width={700}
                destroyOnClose
                maskClosable={true}
            >
                <div className="modal-content">
                    <Form
                        layout="vertical"
                        initialValues={{ remember: true }}
                        onFinish={handleFinishAddBanner}
                        form={form}
                        className="banner-form"
                    >
                        <AntRow gutter={[16, 12]}>
                            <Col span={24}>
                                <Form.Item
                                    label={
                                        <Space>
                                            <FileTextOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                            <span>Tiêu đề tuyển tập</span>
                                        </Space>
                                    }
                                    name="title"
                                    rules={[{ required: true, message: 'Vui lòng nhập tiêu đề tuyển tập!' }]}
                                >
                                    <Input 
                                        placeholder='Nhập tiêu đề tuyển tập' 
                                        className="form-input"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label={
                                        <Space>
                                            <ContainerOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                            <span>Tên tuyển tập</span>
                                        </Space>
                                    }
                                    name="name"
                                    rules={[{ required: true, message: 'Vui lòng nhập tên tuyển tập!' }]}
                                >
                                    <Input 
                                        placeholder='Nhập tên tuyển tập' 
                                        className="form-input"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label={
                                        <Space>
                                            <FileTextOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                            <span>Mô tả</span>
                                        </Space>
                                    }
                                    name="description"
                                    rules={[{ required: true, message: 'Vui lòng nhập mô tả!' }]}
                                >
                                    <Input 
                                        placeholder='Nhập mô tả' 
                                        className="form-input"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label={
                                        <Space>
                                            <BookOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                            <span>Danh sách sách</span>
                                        </Space>
                                    }
                                    name="bookIds"
                                >
                                    <Select
                                        mode="multiple"
                                        allowClear
                                        style={{ width: '100%' }}
                                        placeholder="Chọn sách"
                                        className="form-select"
                                        showSearch
                                        filterOption={(input, option) => {
                                            const label = option?.label || option?.children;
                                            return String(label).toLowerCase().includes(input.toLowerCase());
                                        }}
                                    >
                                        {
                                            bookList.map((item: any) => {
                                                return (
                                                    <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label={
                                        <Space>
                                            <PictureOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                            <span>Hình ảnh</span>
                                        </Space>
                                    }
                                    name="image"
                                    rules={[{ required: true, message: 'Vui lòng chọn hình ảnh!' }]}
                                >
                                    <Upload
                                        multiple={false}
                                        onRemove={(file: any) => {
                                            setImageUploadLst(prev => prev.filter(f => f.name !== file.name));
                                            return true;
                                        }}
                                        listType="picture-card"
                                        showUploadList={{
                                            showRemoveIcon: true,
                                        }}
                                        onChange={(file) => {
                                            handleChangeFileLst(file);
                                        }}
                                        accept=".png, .jpeg, .jpg"
                                        beforeUpload={(file) => {
                                            const isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
                                            const isLt5M = file.size / 1024 / 1024 < 5;
                                            if (!isImage) {
                                                message.error('Chỉ chấp nhận file .jpg, .jpeg, .png');
                                                return false;
                                            }
                                            if (!isLt5M) {
                                                message.error('Kích thước file phải nhỏ hơn 5MB');
                                                return false;
                                            }
                                            setImageUploadLst(prev => [...prev, file]);
                                            return false;
                                        }}
                                    >
                                        {imageUploadLst.length >= 1 ? null : uploadButton}
                                    </Upload>
                                </Form.Item>
                            </Col>
                        </AntRow>

                        <Divider style={{ margin: '16px 0' }} />

                        <div className="modal-actions">
                            <Button
                                onClick={() => setIsOpenModalAdd(false)}
                                className="cancel-button"
                                icon={<CloseOutlined />}
                            >
                                Hủy
                            </Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="save-button"
                                icon={<PlusOutlined />}
                            >
                                Thêm mới
                            </Button>
                        </div>
                    </Form>
                </div>
            </Modal>

            <Modal
                title={
                    <Space>
                        <EyeOutlined />
                        <span>Danh sách sách trong tuyển tập</span>
                    </Space>
                }
                visible={isOpenModalView}
                onCancel={() => setIsOpenModalView(false)}
                footer={null}
                style={{ top: 20, zIndex: 1050 }}
                width={1000}
                className="banner-view-modal"
            >
                <div className="table-area">
                    <CTable
                        tableMainTitle=""
                        allowTextSearch={false}
                        onChangeInput={onChangeInput}
                        onSearch={onSearch}
                        titleOfColumnList={
                            [
                                {
                                    title: 'Tên sách',
                                    dataIndex: 'name',
                                    key: 'name',
                                    render: (text: any, record: any) => {
                                        return (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                {record.book.name}
                                            </div>
                                        );
                                    }
                                },
                                {
                                    title: 'Thời gian tạo',
                                    dataIndex: 'createdAt',
                                    key: 'createdAt',
                                    render: (text: any, record: any) => {
                                        return (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                {moment(record.book.updatedAt).format("DD/MM/YYYY HH:mm:ss")}
                                            </div>
                                        );
                                    }
                                },
                                {
                                    title: 'Giá',
                                    dataIndex: 'price',
                                    key: 'price',
                                    render: (text: any, record: any) => {
                                        return (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                {Utils.formatMoney(record.book.pricePaper) + "VNĐ"}
                                            </div>
                                        );
                                    }
                                },
                                {
                                    title: 'Ảnh bìa',
                                    dataIndex: 'cover',
                                    key: 'cover',
                                    render: (text: any, record: any) => {
                                        return (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <img
                                                    style={{ width: "90px", height: "110px" }}
                                                    src={`${API_URL.HOST}/books/preview-images?id=${record.book.id}`}
                                                    alt=""
                                                />
                                            </div>
                                        );
                                    }
                                }
                            ]
                        }
                        data={lstBookInCollection}
                        totalRecord={lstBookInCollection.length}
                        onChangePagination={() => { }}
                        allowAddObject={true}
                        textSearch="Tìm kiếm sách theo tên"
                        pageSize={10}
                        size={1000}
                    />
                </div>
            </Modal>

            {/* Modal sửa tuyển tập */}

            <Modal
                title={
                    <Space>
                        <EditOutlined />
                        <span>Sửa tuyển tập</span>
                    </Space>
                }
                visible={isOpenModalEdit}
                onCancel={() => setIsOpenModalEdit(false)}
                footer={null}
                style={{ top: 20, zIndex: 1050 }}
                className="banner-edit-modal"
                width={700}
                destroyOnClose
                maskClosable={true}
            >
                <div className="modal-content">
                    <Form
                        layout="vertical"
                        initialValues={{ remember: true }}
                        onFinish={handleEditBanner}
                        form={form}
                        className="banner-form"
                    >
                        <AntRow gutter={[16, 12]}>
                            <Col span={24}>
                                <Form.Item
                                    label={
                                        <Space>
                                            <FileTextOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                            <span>Tiêu đề tuyển tập</span>
                                        </Space>
                                    }
                                    name="title"
                                    rules={[{ required: true, message: 'Vui lòng nhập tiêu đề tuyển tập!' }]}
                                >
                                    <Input 
                                        placeholder='Nhập tiêu đề tuyển tập' 
                                        className="form-input"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label={
                                        <Space>
                                            <ContainerOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                            <span>Tên tuyển tập</span>
                                        </Space>
                                    }
                                    name="name"
                                    rules={[{ required: true, message: 'Vui lòng nhập tên tuyển tập!' }]}
                                >
                                    <Input 
                                        placeholder='Nhập tên tuyển tập' 
                                        className="form-input"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label={
                                        <Space>
                                            <FileTextOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                            <span>Mô tả</span>
                                        </Space>
                                    }
                                    name="description"
                                    rules={[{ required: true, message: 'Vui lòng nhập mô tả!' }]}
                                >
                                    <Input 
                                        placeholder='Nhập mô tả' 
                                        className="form-input"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label={
                                        <Space>
                                            <BookOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                            <span>Danh sách sách</span>
                                        </Space>
                                    }
                                    name="bookIds"
                                >
                                    <Select
                                        mode="multiple"
                                        allowClear
                                        style={{ width: '100%' }}
                                        placeholder="Chọn sách"
                                        className="form-select"
                                        showSearch
                                        filterOption={(input, option) => {
                                            const label = option?.label || option?.children;
                                            return String(label).toLowerCase().includes(input.toLowerCase());
                                        }}
                                    >
                                        {
                                            bookList.map((item: any) => {
                                                return (
                                                    <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label={
                                        <Space>
                                            <PictureOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                            <span>Hình ảnh cũ</span>
                                        </Space>
                                    }
                                    name="image-old"
                                >
                                    <img width={100} height={100} src={`${API_URL.HOST}/collection/thumbnail/${idEdit}?t=${imageCacheKey}`} alt="" />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label={
                                        <Space>
                                            <PictureOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                            <span>Hình ảnh mới</span>
                                        </Space>
                                    }
                                    name="image"
                                    rules={[{ required: true, message: 'Vui lòng chọn hình ảnh!' }]}
                                >
                                    <Upload
                                        multiple={false}
                                        onRemove={(file: any) => {
                                            setImageUploadLst(prev => prev.filter(f => f.name !== file.name));
                                            return true;
                                        }}
                                        listType="picture-card"
                                        showUploadList={{
                                            showRemoveIcon: true,
                                        }}
                                        onChange={(file) => {
                                            handleChangeFileLst(file);
                                        }}
                                        accept=".png, .jpeg, .jpg"
                                        beforeUpload={(file) => {
                                            const isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
                                            const isLt5M = file.size / 1024 / 1024 < 5;
                                            if (!isImage) {
                                                message.error('Chỉ chấp nhận file .jpg, .jpeg, .png');
                                                return false;
                                            }
                                            if (!isLt5M) {
                                                message.error('Kích thước file phải nhỏ hơn 5MB');
                                                return false;
                                            }
                                            setImageUploadLst(prev => [...prev, file]);
                                            return false;
                                        }}
                                    >
                                        {imageUploadLst.length >= 1 ? null : uploadButton}
                                    </Upload>
                                </Form.Item>
                            </Col>
                        </AntRow>

                        <Divider style={{ margin: '16px 0' }} />

                        <div className="modal-actions">
                            <Button
                                onClick={() => setIsOpenModalEdit(false)}
                                className="cancel-button"
                                icon={<CloseOutlined />}
                            >
                                Hủy
                            </Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="save-button"
                                icon={<EditOutlined />}
                            >
                                Cập nhật
                            </Button>
                        </div>
                    </Form>
                </div>
            </Modal>


        </div>


    );
};

export default Banner;